import { render } from "./StudentsByStudentClass.vue?vue&type=template&id=219fa962"
import script from "./StudentsByStudentClass.vue?vue&type=script&lang=js"
export * from "./StudentsByStudentClass.vue?vue&type=script&lang=js"
script.render = render

export default script